import { Stack } from '@mui/material'
import { EmptyStateLargeImage, EmptyStateSmallImage, TinyButton, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { CSSProperties, ReactElement } from 'react'

type EmptyStateComponentProps = {
    title: string
    size?: 'small' | 'medium' | 'large' | 'enormous'
    style?: CSSProperties
    textColor?: string
    button?: {
        label: string
        action: () => void
        leftIcon?: ReactElement
        rightIcon?: ReactElement
    }
}

const SETTINGS = {
    small: {
        width: '105px',
        height: '105px',
        spacing: tokens.SizingSpacing050,
        titleVariant: 'textS' as const,
        BaseImage: EmptyStateSmallImage,
    },
    medium: {
        width: '135px',
        height: '135px',
        spacing: tokens.SizingSpacing050,
        titleVariant: 'textS' as const,
        BaseImage: EmptyStateSmallImage,
    },
    large: {
        width: '175px',
        height: '175px',
        spacing: tokens.SizingSpacing050,
        titleVariant: 'textS' as const,
        BaseImage: EmptyStateSmallImage,
    },
    enormous: {
        width: '270px',
        height: '270px',
        spacing: tokens.SizingSpacing200,
        titleVariant: 'headline3' as const,
        BaseImage: EmptyStateLargeImage,
    },
}

export const EmptyState = ({ title, style, button, textColor = tokens.ColorTextBoldest, size = 'medium' }: EmptyStateComponentProps) => {
    const settings = SETTINGS[size]
    return (
        <Stack direction="column" alignItems="center" gap={settings.spacing} style={style}>
            <Stack height="100%" width="100%" gap={settings.spacing} justifyContent="center" textAlign="center" alignItems="center">
                <settings.BaseImage height={settings.height} width={settings.width} />
                <Typography variant={settings.titleVariant} color={textColor}>
                    {title}
                </Typography>
            </Stack>
            {button && <TinyButton onClick={button.action} label={button.label} leftIcon={button.leftIcon} rightIcon={button.rightIcon} />}
        </Stack>
    )
}

export default EmptyState
